import React from 'react'

const statusColors = {
  approved: '#2E7D32',
  pending: '#F4D03F',
  rejected: '#A52828',
  expired: '#1E88E5',
  cancelled: '#6B7280',
  timeout: '#FF8C00',
  default: '#A15C5C',
}

const StatusTag = ({ status }) => {
  const isValidString = typeof status === 'string' && status.trim() !== ''
  const normalizedStatus = isValidString ? status.trim().toLowerCase() : 'default'
  const color = statusColors[normalizedStatus]

  return (
    <span style={{ color, textTransform: 'capitalize' }}>
      {isValidString ? normalizedStatus : ''}
    </span>
  )
}

export default StatusTag
